import React from 'react';

const Content = ({ title, fit = false, children }) => {
    return (
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor paddingTop-mobile">
            { children }
		</div>
    );
};

export default Content;